import { useState } from 'react';
export interface ProfitNavigation { history: (string | undefined)[]; chosen?: string; expanded?: string }
export function useProfitNavigation(value?: ProfitNavigation, onChange?: (next: ProfitNavigation) => void) {
  const [local, setLocal] = useState<ProfitNavigation>({ history: [undefined] });
  const current = value || local;
  return { ...current, update: (patch: Partial<ProfitNavigation>) => (onChange || setLocal)({ ...current, ...patch }) };
}
